<template>
  <div class="mid-pannel">
    <div class="map" :style="gridStyle" v-if="records.length">
      <MapPiece 
        v-for="(record, idx) in records"
          :key="idx + 'n'"
          :record="record.metadata"
          :hoveredType="hoveredType"
          :hoveredValue="hoveredValue"
          :selectedType="selectedType"
          :selectedValue="selectedValue"
          :selection="selection"
          :mouseover="mouseover"
          :hoveredRecord="hoveredRecord"
          @recordMouseover="recordMouseover(record)"
          @recordMouseout="recordMouseout()"
      />
      <BRMapPiece 
        v-for="(record, idx) in brRecords"
          :key="idx + 'm'"
          :record="record.metadata"
          :hoveredType="hoveredType"
          :hoveredValue="hoveredValue"
          :selectedType="selectedType"
          :selectedValue="selectedValue"
          :selection="selection"
          :mouseover="mouseover"
          :hoveredRecord="hoveredRecord"
          @recordMouseover="recordMouseover(record)"
          @recordMouseout="recordMouseout()"
      />
    </div>
  </div>
</template>

<script>
import MapPiece from './MapPiece.vue';
import BRMapPiece from './BRMapPiece.vue';

export default {
  name: 'Map',
  components: {
    MapPiece,
    BRMapPiece,
  },
  props: [
    'records',
    'brRecords',
    'selection',
  ],
  data(){
    return {
      mouseover: false,
      hoveredType: null,
      hoveredValue: null,
      selectedType: null,
      selectedValue: null,
      hoveredRecord: null,
      gridStyle: {
        display: 'grid',
        gridTemplateColumns: 'repeat(27, 1fr)',
        gridTemplateRows: 'repeat(29, 1fr)',
      },
    }
  },
  methods: {
    recordMouseover(record){
      this.$emit('recordMouseover', record.metadata);
      this.mouseover = true;
      this.hoveredRecord = record.metadata.code;
    },
    recordMouseout(){
      this.$emit('recordMouseout');
      this.mouseover = false;
      this.hoveredRecord = null;
    },
    unhighlight(){
      this.hoveredCountry = null;
      this.hoveredGenre = null;
      this.hoveredYear = null;
      this.hoverTechnique = null;
      this.hoveredYear = null;
    },
    hover(type, value){
      this.hoveredType = type;
      this.hoveredValue = value;
    },
    unhover(){
      this.hoveredType = null;
      this.hoveredValue = null;
    },
    select(type, value){
      this.selectedType = type;
      this.selectedValue = value;
    },
    cleanSelection(){
      this.selectedType = null;
      this.selectedValue = null;
    }

  },
  mounted() {
    const w = this.$el.clientWidth / 29;
    const h = w * 4 / 5;
    const ponderator = .95;
    this.gridStyle.gridTemplateColumns = `repeat(27, ${w * ponderator}px)`;
    this.gridStyle.gridTemplateRows = `repeat(29, ${h * ponderator}px)`;
  }
}
</script>

<style scoped>
  .mid-pannel {
    display: flex;
    justify-content: center;
    padding: 0 40px;
    height: 100%;
    width: 100%;
  }
</style>